
import { defineComponent } from 'vue'
import IpTracker from '@/components/IpTracker.vue'

export default defineComponent({
  name: 'AppHeader',

  components: { IpTracker }
})
